import React from "react";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";
import { useControlBarRenameFolderButton } from "./use-control-bar-rename-folder-button-hook";

export const ControlBarRenameFolderButton = () => {
  const { openRenameInput, tooltip, icon, disabled, nodeSelectionNodeData } =
    useControlBarRenameFolderButton();

  return (
    <>
      {nodeSelectionNodeData && (
        <IconButton
          key={tooltip}
          tooltip={tooltip}
          tooltipPosition="bottom"
          fun={openRenameInput}
          icon={icon}
          disabled={disabled}
        />
      )}
    </>
  );
};
